import React, { useState } from 'react';

import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

export const Dialog = (props) => {

    const { options, title, actionButtons, children, isCustomActions = false, onClose = () => { }, closeButtonText = "Close" } = props;

    return <DialogMUI open={true} {...options}>
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>
            {children}
        </DialogContent>
        <DialogActions>
            {!isCustomActions && actionButtons && actionButtons.map((e, i) => <React.Fragment key={`dialog_b_${i}`}>
                {e}
            </React.Fragment>)}
            {isCustomActions && actionButtons &&
                <div style={{ width: '100%', display: 'flex', whiteSpace: 'nowrap', marginRight: 20, marginLeft: 20 }}>
                    {actionButtons.map((e, i) => <React.Fragment key={`dialog_b_${i}`}>
                        {e}
                    </React.Fragment>)}
                </div>}
            {!actionButtons && <Button color={'primary'} onClick={() => onClose()}>{closeButtonText}</Button>}
        </DialogActions>
    </DialogMUI>
}

export default () => {
    var [isShowing, isShowing_set] = useState(false);
    var [content, content_set] = useState(null);
    var [title, title_set] = useState(null);
    var [options, options_set] = useState({ maxWidth: 'md' });
    var [actionButtons, actionButtons_set] = useState();


    var ret = "";

    if (isShowing) {
        ret = <Dialog actionButtons={actionButtons ? actionButtons : [<Button color={'primary'} onClick={() => isShowing_set(false)}>Close</Button>]} title={title} options={options}>{content}</Dialog>
    }

    //returns an array with the following items
    //1. the item to render
    //2. a method to show the dialog
    //3. a method to hide the dialog
    return [ret, (props) => {
        const { content, actionButtons, title, options } = props;
        isShowing_set(true);
        content_set(content);
        actionButtons_set(actionButtons);
        title_set(title);
        options_set(options);
    }, () => {
        isShowing_set(false);
    }];
}



// WEBPACK FOOTER //
// ./src/hooks/useDialog.js